import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { memo } from 'react';
import { useDropEventListContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventList.context';
import { maxDaresReachedMessage } from 'root/src/shared/constants/dropEvent';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
export const DropUserInfoWidget = memo(() => {
    const { dropEvent } = useDropEventListContext();
    if (!dropEvent.dropUserInfo) {
        return <CheckOutDaresButton />;
    }
    const isMaxDaresReached = dropEvent.dropUserInfo.countOfAcceptedDares >= dropEvent.dropUserInfo.maxDares;
    const isAbleToParticipate = dropEvent.dropUserInfo.maxDares > 0;
    if (!isAbleToParticipate) {
        return <NotAbleToParticipate />;
    }
    if (isMaxDaresReached) {
        return <MaxDaresReached />;
    }
    return <CheckOutDaresButton />;
});
function NotAbleToParticipate() {
    return (<div className="flex flex-col gap-2">
			<FontAwesomeIcon size="lg" icon={faLock}/>
			<span className="text-pink text-xs text-center">
				Need more Viewers to Participate
			</span>
		</div>);
}
function MaxDaresReached() {
    return (<div className="flex flex-col gap-2">
			<FontAwesomeIcon size="lg" icon={faLock}/>
			<span className="text-pink text-xs text-center">
				{maxDaresReachedMessage}
			</span>
		</div>);
}
function CheckOutDaresButton() {
    return (<div className="flex justify-center items-center">
			<ButtonNew className="font-bold">Check Out Dares</ButtonNew>
		</div>);
}
